<div class="row" *ngIf="(cmsBlocks$ | async) as cmsBlocks">
    <ng-container *ngFor="let cmsBlock of cmsBlocks">
        <div class="col" [innerHTML]="sanitizer.bypassSecurityTrustHtml(cmsBlock.content)"></div>
    </ng-container>
</div>
<!-- <mat-spinner *ngIf="!(cmsText$ | async)" [diameter]="50"></mat-spinner> -->
